var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "../Components/FormGroup.vue";
var PostalAddress = /** @class */ (function (_super) {
    __extends(PostalAddress, _super);
    function PostalAddress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localLine1 = _this.line1 || null;
        _this.localLine2 = _this.line2 || null;
        _this.localCity = _this.city || null;
        _this.localState = _this.state || null;
        _this.localZip = _this.zip || null;
        return _this;
    }
    PostalAddress.prototype.onLine1Changed = function (val) { this.$emit("update:line1", val); };
    PostalAddress.prototype.onLine2Changed = function (val) { this.$emit("update:line2", val); };
    PostalAddress.prototype.onCityChanged = function (val) { this.$emit("update:city", val); };
    PostalAddress.prototype.onStateChanged = function (val) { this.$emit("update:state", val); };
    PostalAddress.prototype.onZipChanged = function (val) { this.$emit("update:zip", val); };
    __decorate([
        Prop({ type: String, default: "Address" })
    ], PostalAddress.prototype, "title", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], PostalAddress.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], PostalAddress.prototype, "$v", void 0);
    __decorate([
        Prop({ type: String })
    ], PostalAddress.prototype, "line1", void 0);
    __decorate([
        Watch("localLine1")
    ], PostalAddress.prototype, "onLine1Changed", null);
    __decorate([
        Prop({ type: String, default: "line1" })
    ], PostalAddress.prototype, "mLine1", void 0);
    __decorate([
        Prop({ type: String, default: "line1" })
    ], PostalAddress.prototype, "$vLine1", void 0);
    __decorate([
        Prop({ type: String })
    ], PostalAddress.prototype, "line2", void 0);
    __decorate([
        Watch("localLine2")
    ], PostalAddress.prototype, "onLine2Changed", null);
    __decorate([
        Prop({ type: String, default: "line2" })
    ], PostalAddress.prototype, "mLine2", void 0);
    __decorate([
        Prop({ type: String, default: "line2" })
    ], PostalAddress.prototype, "$vLine2", void 0);
    __decorate([
        Prop({ type: String })
    ], PostalAddress.prototype, "city", void 0);
    __decorate([
        Watch("localCity")
    ], PostalAddress.prototype, "onCityChanged", null);
    __decorate([
        Prop({ type: String, default: "city" })
    ], PostalAddress.prototype, "mCity", void 0);
    __decorate([
        Prop({ type: String, default: "city" })
    ], PostalAddress.prototype, "$vCity", void 0);
    __decorate([
        Prop({ type: String })
    ], PostalAddress.prototype, "state", void 0);
    __decorate([
        Watch("localState")
    ], PostalAddress.prototype, "onStateChanged", null);
    __decorate([
        Prop({ type: String, default: "state" })
    ], PostalAddress.prototype, "mState", void 0);
    __decorate([
        Prop({ type: String, default: "state" })
    ], PostalAddress.prototype, "$vState", void 0);
    __decorate([
        Prop({ type: String })
    ], PostalAddress.prototype, "zip", void 0);
    __decorate([
        Watch("localZip")
    ], PostalAddress.prototype, "onZipChanged", null);
    __decorate([
        Prop({ type: String, default: "zip" })
    ], PostalAddress.prototype, "mZip", void 0);
    __decorate([
        Prop({ type: String, default: "zip" })
    ], PostalAddress.prototype, "$vZip", void 0);
    PostalAddress = __decorate([
        Component({
            name: "PostalAddress",
            components: {
                FormGroup: FormGroup
            }
        })
    ], PostalAddress);
    return PostalAddress;
}(Vue));
export default PostalAddress;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/PostalAddress.vue
// module id = 93
// module chunks = 2 3 4 6 10